'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import ContentLoader from 'react-content-loader';
import { usePrefersReducedMotion } from '~/hooks/usePrefersReducedMotion';
type JourneyContentPlaceholderProps = {
  children?: React.ReactNode;
};
export default function JourneyContentPlaceholder(t0) {
  const $ = _c(38);
  const {
    children
  } = t0;
  const t = useTranslations();
  const prefersReducedMotion = usePrefersReducedMotion();
  let t1;
  if ($[0] !== children || $[1] !== t) {
    t1 = children ? children : <h2 className="hidden font-serif font-bold text-center md:block md:text-3xl md:mt-12">{t("common.loading")}</h2>;
    $[0] = children;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = !prefersReducedMotion;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <rect width="100%" height="100%" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <ContentLoader animate={t2} className="relative w-full h-full rounded-xl" uniqueKey="header">{t3}</ContentLoader>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !prefersReducedMotion;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <rect width="100%" height="100%" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <ContentLoader animate={t5} className="relative w-full h-8 mt-4 rounded-lg" uniqueKey="title_mobile">{t6}</ContentLoader>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = !prefersReducedMotion;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <rect width="100%" height="100%" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8) {
    t10 = <ContentLoader animate={t8} className="relative h-10 mt-4 rounded-lg" uniqueKey="price_mobile">{t9}</ContentLoader>;
    $[10] = t8;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = !prefersReducedMotion;
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <rect width="100%" height="100%" />;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== t11) {
    t13 = <ContentLoader animate={t11} className="relative w-1/2 h-12 mt-4 rounded-lg" uniqueKey="cta_mobile">{t12}</ContentLoader>;
    $[13] = t11;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== t10 || $[16] !== t13 || $[17] !== t7) {
    t14 = <div className="px-4 md:hidden">{t7}{t10}{t13}</div>;
    $[15] = t10;
    $[16] = t13;
    $[17] = t7;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <hr className="mx-4 mt-4 md:hidden" />;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  const t16 = !prefersReducedMotion;
  let t17;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <rect width="100%" height="100%" />;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] !== t16) {
    t18 = <ContentLoader animate={t16} className="relative w-2/3 h-8 px-4 mt-12 rounded-lg md:mt-14 md:px-0" uniqueKey="map_title">{t17}</ContentLoader>;
    $[21] = t16;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  const t19 = !prefersReducedMotion;
  let t20;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <rect width="100%" height="100%" />;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] !== t19) {
    t21 = <ContentLoader animate={t19} className="relative aspect-[4/3] mt-4 md:rounded-lg md:mt-0 md:col-span-2 md:w-full" uniqueKey="map">{t20}</ContentLoader>;
    $[24] = t19;
    $[25] = t21;
  } else {
    t21 = $[25];
  }
  const t22 = !prefersReducedMotion;
  let t23;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <rect width="100%" height="100%" />;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t22) {
    t24 = <ContentLoader animate={t22} className="relative px-4 mt-6 rounded md:h-full md:w-full aspect-square md:aspect-auto md:mt-0 md:rounded-lg md:px-0" uniqueKey="map_overview">{t23}</ContentLoader>;
    $[27] = t22;
    $[28] = t24;
  } else {
    t24 = $[28];
  }
  let t25;
  if ($[29] !== t21 || $[30] !== t24) {
    t25 = <div className="md:grid md:mt-4 md:grid-cols-3 md:gap-4">{t21}{t24}</div>;
    $[29] = t21;
    $[30] = t24;
    $[31] = t25;
  } else {
    t25 = $[31];
  }
  let t26;
  if ($[32] !== t1 || $[33] !== t14 || $[34] !== t18 || $[35] !== t25 || $[36] !== t4) {
    t26 = <div><div className="container relative mx-auto md:px-8 md:my-16">{t1}{t4}{t14}{t15}{t18}{t25}</div></div>;
    $[32] = t1;
    $[33] = t14;
    $[34] = t18;
    $[35] = t25;
    $[36] = t4;
    $[37] = t26;
  } else {
    t26 = $[37];
  }
  return t26;
}